const svg = `data:image/svg+xml,<svg fill="none" width="100" height="100" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><g transform="translate(50,50)"><path d="M50 100c27.6142 0 50-22.3858 50-50S77.6142 0 50 0 0 22.3858 0 50s22.3858 50 50 50Z" fill="%23002D5C"/><path d="M7.92492 49.6778c.92305.1866 1.88242-.0005 2.66768-.5203.7852-.5199 1.3322-1.33 1.521-2.2526.1866-.923-.0006-1.8824-.5204-2.6676-.5198-.7853-1.3299-1.3323-2.25254-1.521-.4571-.093-.92802-.095-1.3859-.006-.45789.0891-.89375.2674-1.2827.5249-.38896.2575-.72339.5891-.9842.9758-.26081.3867-.4429.8211-.53585 1.2782-.1866.923.00055 1.8824.52038 2.6676.51983.7853 1.32992 1.3323 2.25253 1.521Zm8.04228 5.9226c-.0453-.2093-.1055-.415-.1801-.6157l-.3561-1.2315c-.2324-1.0794-.8816-2.0234-1.8064-2.6266-.9249-.6032-2.0505-.8168-3.132-.5945-1.07941.2325-2.02339.8817-2.6266 1.8065-.60322.9248-.81686 2.0504-.59448 3.132.04339.2097.10364.4156.18014.6157l.35183 1.2315c.23145 1.081.88094 2.0267 1.80682 2.6309.92589.6042 2.05309.8178 3.13579.5943 1.0803-.2324 2.025-.8822 2.6283-1.808.6033-.9258.8164-2.0524.5928-3.1346Zm69.6825-30.8871c-3.5059-1.7132-5.6506 2.0483-5.6506 2.0483l-15.565 36.8601s-6.5804-20.1809-6.8694-20.8846l-.0419-.0922.1047.3393c0-.0251-.0209-.0502-.0293-.0796l-.1843-.6031-2.2744-7.0621c-.1673-.6396-.4742-1.2343-.8986-1.7412-.4244-.507-.9558-.9137-1.556-1.1909-1.052-.4685-2.2471-.5001-3.3224-.0877s-1.9429 1.2349-2.4119 2.2868l-9.9103 23.6324-3.3844-9.8601-.0378-.1047c0-.0252-.0251-.0503-.0335-.0796l-.4188-1.2147-2.2116-6.4841-.0587-.1675c-.423-1.0343-1.2287-1.8655-2.2493-2.3205-.5233-.2354-1.088-.3648-1.6615-.3807-.5736-.0159-1.1446.082-1.6801.288-.5355.206-1.0249.5161-1.4399.9123-.415.3963-.7473.8708-.9779 1.3962l-4.9091 12.9848-.155.3937c-.4404 1.0122-.4635 2.1572-.0643 3.1863.3993 1.0291 1.1886 1.859 2.1963 2.3093.8208.3627 1.7364.4522 2.6119.2554.8755-.1968 1.6646-.6696 2.2512-1.3487.2856-.3264.5187-.6952.6911-1.0932l.9467-2.3289 5.8641 17.8646c.1686.5463.4433 1.0539.8084 1.4939.3651.4399.8133.8036 1.3191 1.0701.5058.2665 1.0592.4306 1.6285.483.5693.0524 1.1433-.008 1.6892-.1778.5903-.1818 1.135-.4872 1.5979-.896.463-.4088.8336-.9115 1.087-1.4747l10.0151-23.8754v.0293l9.5879 29.0526c.3031.754.8231 1.4012 1.4941 1.8598.6711.4585 1.463.7077 2.2756.7162 2.9572.1424 4.1887-2.576 4.1887-2.576l20.0344-48.0816s1.11-3.5353-2.3959-5.2568ZM52.6263 43.8136l.222-.532v-.0209l-.222.5529Zm-33.1532 16.742c-1.0102-.4383-2.1523-.4612-3.1792-.0638-1.027.3975-1.8561 1.1833-2.308 2.1875l-1.311 2.9321c-.4121.9959-.4244 2.1125-.0344 3.1173.3901 1.0048 1.1525 1.8206 2.1287 2.2776 1.0023.4628 2.1467.5112 3.1844.1347s1.8848-1.1475 2.3572-2.1452l1.1184-2.5132c.9173-2.1278.1633-4.9929-1.9561-5.927Z" fill="%23fff"/><path opacity=".7" d="m37.0403 58.1389-3.3844-9.8601-.0378-.1047c-.3727-.9969-1.3906-2.0567-2.7854-1.6545-1.1226.3309-1.7215 1.4199-1.998 2.0356l-2.4043 5.8642 5.9018 17.9107c.1687.5462.4434 1.0539.8085 1.4938.365.44.8133.8036 1.3191 1.0701.5057.2665 1.0591.4307 1.6284.4831.5693.0523 1.1434-.0081 1.6893-.1778.5902-.1818 1.135-.4873 1.5979-.8961.463-.4088.8335-.9115 1.087-1.4747l.8964-2.1362-4.3185-12.5534Z" fill="url(%23a)"/><path opacity=".7" d="m64.4341 63.5882-1.1435-3.4891-5.6379-17.1149c-.3393-1.0555-1.3613-2.1571-2.8022-1.7383-1.1226.3309-1.7216 1.4242-1.9938 2.0357L50.465 48.974v.0293l9.5878 29.0526c.3032.754.8231 1.4012 1.4942 1.8598.671.4585 1.4629.7077 2.2756.7162 2.9572.1424 4.1886-2.576 4.1886-2.576l.6618-1.5876-4.2389-12.8801Z" fill="url(%23b)"/><defs><linearGradient id="a" x1="28.8682" y1="58.2687" x2="23.5947" y2="55.3451" gradientUnits="userSpaceOnUse"><stop stopColor="%234D4A4A" stopOpacity="0"/><stop offset="1" stopColor="%23221F1F"/></linearGradient><linearGradient id="b" x1="51.2566" y1="56.3837" x2="42.5945" y2="51.5794" gradientUnits="userSpaceOnUse"><stop stopColor="%23221F1F" stopOpacity="0"/><stop offset=".02" stopColor="%23221F1F" stopOpacity=".04"/><stop offset=".19" stopColor="%23221F1F" stopOpacity=".31"/><stop offset=".36" stopColor="%23221F1F" stopOpacity=".53"/><stop offset=".53" stopColor="%23221F1F" stopOpacity=".71"/><stop offset=".69" stopColor="%23221F1F" stopOpacity=".83"/><stop offset=".85" stopColor="%23221F1F" stopOpacity=".9"/><stop offset="1" stopColor="%23221F1F" stopOpacity=".93"/></linearGradient></defs></g></svg>`;
const watermarkCss = (bgColor) => `
  background-color: ${bgColor};
  background-image: url('${svg}');
  background-size: 100px 100px;
  inset: -15px 0 -15px -15px;
  opacity: 0.04;
  overflow: hidden;
  pointer-events: none;
  position: absolute;
  z-index: 9999;
`;
const watermarkChildCss = `
  background-image: url('${svg}');
  background-size: 100px 100px;
  content: '';
  display: block;
  height: 120%;
  margin: -50px 0 0 50px;
  position: absolute;
  top: 0;
  width: 100%;
`;
function randomNumber(min, max) {
  return Math.random() * (max - min) + min;
}
function randomRgba(alpha = 1) {
  const red = Math.round(Math.random() * 255);
  const green = Math.round(Math.random() * 255);
  const blue = Math.round(Math.random() * 255);
  return `rgba(${red},${green},${blue},${alpha})`;
}
function createRandomWatermarkColor() {
  const alpha = randomNumber(0.1, 0.3);
  return randomRgba(alpha);
}
class Watermark {
  #node = null;
  #observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.type === "childList" || m.type === "attributes") {
        if (this.#timer) {
          clearInterval(this.#timer);
          this.#timer = null;
        }
        this.#inject();
        break;
      }
    }
  });
  #timer = null;
  static #instances = [];
  static get instancesCount() {
    return Watermark.#instances.length;
  }
  constructor() {
    Watermark.#instances.push(this);
    this.#inject();
  }
  #isActive() {
    const firstInstance = Watermark.#instances.at(0);
    return firstInstance === this;
  }
  #shuffleCss(cssString) {
    const rules = cssString.split(/\r?\n/);
    for (let i = rules.length - 1; i > 0; i--) {
      const randIdx = Math.floor(Math.random() * (i + 1));
      const swap = rules[i];
      rules[i] = rules[randIdx];
      rules[randIdx] = swap;
    }
    return rules.join("");
  }
  #appendElements() {
    const nextEl = document.createElement("p", {});
    const nextChild = document.createElement("span", {});
    if (this.#node) {
      this.#observer.disconnect();
      this.#node.remove();
      this.#node = null;
    }
    const bgColor = createRandomWatermarkColor();
    nextEl.style.cssText = this.#shuffleCss(watermarkCss(bgColor));
    nextChild.style.cssText = this.#shuffleCss(watermarkChildCss);
    nextEl.appendChild(nextChild);
    this.#node = document.body.appendChild(nextEl);
    this.#observer.observe(nextEl, { attributes: true, childList: true, subtree: true });
  }
  #inject() {
    if (this.#isActive()) {
      this.#appendElements();
      this.#timer = setInterval(() => {
        if (!this.#node?.isConnected) {
          this.#appendElements();
        }
      }, 3 * 1e3);
    }
  }
}
export {
  Watermark
};
//# sourceMappingURL=Watermark.js.map
